"use client"

import { useState } from 'react';
import styles from './Tooltip.module.css';

export interface TooltipProps {
	text?: string;
	placement?: 'top' | 'right' | 'left' | 'bottom';
	children: React.ReactNode;
	className?: string;
}

export function Tooltip(props: TooltipProps) {
	const { text, placement = 'top', className = '', children } = props;

	const [isVisible, setIsVisible] = useState(false);

	const showTooltip = () => {
		setIsVisible(!!text);
	};

	const hideTooltip = () => {
		setIsVisible(false);
	};

	return (
		<div className={`${styles.tooltip} ${className}`} onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
			{children}
			{isVisible && (
				<div className={`${styles.wrapper} ${styles[placement]}`}>
					<div className={styles.arrow}></div>
					{text}
				</div>
			)}
		</div>
	);
}

export default Tooltip;
